<template>
  <div class="reviews-container" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="container container-xl">
      <div class="row">
        <div class="col-xs-12 text-center">
          <h3 class="reviews-header">Hometown Dealer Testimonials</h3>
        </div>
      </div>
      <div class="row">
        <div class="carousel slide multi-reviews-carousel hidden-xs" data-ride="carousel" id="multiReviewsDesktop">
          <div class="carousel-inner">
            <div class="item active">
              <div class="col-xs-12 col-sm-4">
                <div class="review-card">
                  <div class="review-title">
                    <div class="title-content">
                      <h5 class="review-author">Tammy</h5>
                      <p class="review-date">Jul 15 2022</p>
                    </div>
                    <div class="title-stars"><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i></div>
                  </div>
                  <div class="review-body">
                    <p>"Best service department BY FAR! I have had many different brands of cars through the years and this place is not only organized and friendly, but up to date on technologies to get me in and out quickly! I received a call and text when my car was done and even a text video of the tire and break in..."</p>
                  </div>
                  <div class="review-link"><a href="#">Read More</a></div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="col-xs-12 col-sm-4">
                <div class="review-card">
                  <div class="review-title">
                    <div class="title-content">
                      <h5 class="review-author">Jerry C</h5>
                      <p class="review-date">Jul 24 2022</p>
                    </div>
                    <div class="title-stars"><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i></div>
                  </div>
                  <div class="review-body">
                    <p>"This is my second Mazda that I leased from lesli Johnson. She is the ultimate professional. I hope that she is still working at Bob King Mazda when I am ready for my 3rd automobile. Thank you lesli"
                    </p>
                  </div>
                  <div class="review-link"><a href="#">Read More</a></div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="col-xs-12 col-sm-4">
                <div class="review-card">
                  <div class="review-title">
                    <div class="title-content">
                      <h5 class="review-author">Beth Smith</h5>
                      <p class="review-date">Mar 3 2022</p>
                    </div>
                    <div class="title-stars"><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i></div>
                  </div>
                  <div class="review-body">
                    <p>"We had a wonderful experience buying a new vehicle from Shaun. He was SO nice and helpful. We have bought a lot of cars over the years but this was our best experience. Thank you!"
                    </p>
                  </div>
                  <div class="review-link"><a href="#">Read More</a></div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="col-xs-12 col-sm-4">
                <div class="review-card">
                  <div class="review-title">
                    <div class="title-content">
                      <h5 class="review-author">John Hinson</h5>
                      <p class="review-date">Sep 12 2022</p>
                    </div>
                    <div class="title-stars"><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i></div>
                  </div>
                  <div class="review-body">
                    <p>"This is the second time that i have had the opportunity to do business with you, and each time you have been a consummate professional.Thank you twice!"</p>
                  </div>
                  <div class="review-link"><a href="#">Read More</a></div>
                </div>
              </div>
            </div>
          </div><a class="left carousel-control" data-slide="prev" href="#multiReviewsDesktop"><img alt="Previous"
              class="carousel-chevron chevron-left chevron-dark reviews-chevron"
              src="../../static/images/common-icons/left-arrow-black.png"></a><a
            class="right carousel-control" data-slide="next" href="#multiReviewsDesktop"><img alt="Next"
              class="carousel-chevron chevron-right chevron-dark reviews-chevron"
              src="../../static/images/common-icons/right-arrow-black.png"></a>
        </div>
        <div class="col-xs-12">
          <div class="carousel slide multi-reviews-carousel visible-xs" data-ride="carousel" id="multiReviewsMobile">
            <div class="carousel-inner">
              <div class="item active">
                <div class="col-xs-12">
                  <div class="review-card">
                    <div class="review-title">
                      <div class="title-content">
                        <h5 class="review-author">Tammy</h5>
                        <p class="review-date">Jul 15 2022</p>
                      </div>
                      <div class="title-stars"><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i></div>
                    </div>
                    <div class="review-body">
                      <p>"Best service department BY FAR! I have had many different brands of cars through the years and this place is not only organized and friendly, but up to date on technologies to get me in and out quickly! I received a call and text when my car was done and even a text video of the tire and break in..."</p>
                    </div>
                    <div class="review-link"><a href="#">Read More</a></div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="col-xs-12">
                  <div class="review-card">
                    <div class="review-title">
                      <div class="title-content">
                        <h5 class="review-author">Jerry C</h5>
                        <p class="review-date">Jul 24 2022</p>
                      </div>
                      <div class="title-stars"><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i></div>
                    </div>
                    <div class="review-body">
                      <p>"This is my second Mazda that I leased from lesli Johnson. She is the ultimate professional. I hope that she is still working at Bob King Mazda when I am ready for my 3rd automobile. Thank you lesli"
                      </p>
                    </div>
                    <div class="review-link"><a href="#">Read More</a></div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="col-xs-12">
                  <div class="review-card">
                    <div class="review-title">
                      <div class="title-content">
                        <h5 class="review-author">John C Hinson</h5>
                        <p class="review-date">Sep 12 2022</p>
                      </div>
                      <div class="title-stars"><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i><i aria-hidden="true" class="fa fa-star"></i></div>
                    </div>
                    <div class="review-body">
                      <p>"This is the second time that i have had the opportunity to do business with you, and each time you have been a consummate professional.Thank you twice!"</p>
                    </div>
                    <div class="review-link"><a href="#">Read More</a></div>
                  </div>
                </div>
              </div>
            </div><a class="left carousel-control" data-slide="prev" href="#multiReviewsMobile"><img alt="Previous" class="carousel-chevron chevron-left chevron-dark reviews-chevron" src="../../static/images/common-icons/left-arrow-black.png"></a><a
              class="right carousel-control" data-slide="next" href="#multiReviewsMobile"><img alt="Next" class="carousel-chevron chevron-right chevron-dark reviews-chevron" src="../../static/images/common-icons/right-arrow-black.png"></a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 text-center"><a class="btn reviews-btn" href="#">View All</a></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        brand: this.$store.state.chosenBrand
      }
    },
    computed: {
      brandName () {
        if (this.brand === 'none') {
          return 'Brand';
        } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
          return this.brand.toUpperCase();
        } else {
          return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
        }
      }
    },
    mounted() {
      (function () {
        var reviewCarousel = {
        init: function() {

          $('#multiReviewsDesktop .item').each(function () {
            var next = $(this).next();
              if (!next.length) {
                next = $(this).siblings(':first');
              }
              next.children(':first-child').clone().appendTo($(this));

              for (var i = 0; i < $(this).siblings.length - 1; i++) {
                next = next.next();
                if (!next.length) {
                  next = $(this).siblings(':first');
                }
                next.children(':first-child').clone().appendTo($(this));
                }
              });
            }
          }

          var setHeights = {
            init:function() {
              setHeights.resetDesktopHeights();
              setHeights.resetMobileHeights();

              $(window).resize(function() {
                setHeights.resetDesktopHeights();
                setHeights.resetMobileHeights();
              });
            },

            resetDesktopHeights: function() {
              var heights = [];
              $('#multiReviewsDesktop .item').each(function() {
                heights.push($(this).height());
              });

              $('#multiReviewsDesktop .item').height(Math.max(...heights));
            },

            resetMobileHeights: function() {
              var heights = [];
              $('#multiReviewsMobile .item').each(function() {
                heights.push($(this).height());
              });

              $('#multiReviewsMobile .item').height(Math.max(...heights));
            }
          }

          $('#multiReviewsDesktop').carousel({
            interval: 6000
          })
          $('#multiReviewsMobile').carousel({
            interval: 6000
          })
    
        $(document).ready(reviewCarousel.init);
      })(jQuery);
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .reviews-container {
    background: #f5f5f5;
    padding-top: calc(4% + 30px);
    padding-bottom: calc(4% + 30px);
  }
  .reviews-container .reviews-header {
    font-size: 24px;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 1em;
    color: #101010;
  }
  .reviews-container .carousel .review-card {
    background: #fff;
    padding: 30px;
    border: 1px solid #d5d5d5;
    border-radius: 0px;
    margin: auto;
    max-width: 360px;
    height: 100%;
  }
  .reviews-container .carousel .review-card .review-title {
    border-bottom: 2px solid #bdbdbd;
    width: 100%;
  }
  .reviews-container .carousel .review-card .review-title .title-content, .reviews-container .carousel .review-card .review-title .title-stars {
    display: inline-block;
  }
  .reviews-container .carousel .review-card .review-title .title-content {
    width: 60%;
    overflow: hidden;
    white-space: nowrap;
  }
  .reviews-container .carousel .review-card .review-title .title-stars {
    width: 40%;
    float: right;
    text-align: right;
    white-space: nowrap;
    overflow: visible;
  }
  .reviews-container .carousel .review-card .review-title .title-content .review-author {
    letter-spacing: 1px;
    color: #101010;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
    margin-top: 6px;
  }
  .reviews-container .carousel .review-card .review-title .title-content .review-date {
    letter-spacing: 1px;
    color: #999;
    font-size: 13px;
  }
  .reviews-container .carousel .review-card .review-title .title-stars i, .reviews-container .carousel .review-card .review-title .title-stars .fa-star:before {
    color: #101010;
    font-size: 14px;
    margin-left: 1px;
    margin-top: 6px;
  }
  .reviews-container .carousel .review-card .review-body {
    padding-top: 30px;
    padding-bottom: 30px;
    margin-bottom: auto;
  }
  .reviews-container .carousel .review-card .review-body p {
    position: relative;
    height: 176px;
    color: #101010;
    overflow: hidden;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: .5px;
  }
  .reviews-container .carousel .review-card .review-body p:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 50%;
    height: 22px;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 80%);
  }
  @supports (-webkit-line-clamp: 2) {
    .reviews-container .carousel .review-card .review-body p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 8;
      -webkit-box-orient: vertical;
    }
    .reviews-container .carousel .review-card .review-body p:after {
      display: none;
    }
  }
  .reviews-container .carousel .review-card .review-link a {
    color: #737373;
    font-size: 13px;
    text-decoration: none;
    text-transform: uppercase;
    padding-bottom: 5px;
    border-bottom: 2px solid #737373;
    border-radius: 0 !important;
    -moz-transition: all 300ms ease-out;
    -webkit-transition: all 300ms ease-out;
    -o-transition: all 300ms ease-out;
    transition: all 300ms ease-out;
  }
  .reviews-container .carousel .review-card .review-link a:hover,
  .reviews-container .carousel .review-card .review-link a:active,
  .reviews-container .carousel .review-card .review-link a:focus {
    color: #101010;
    border-bottom-color: #101010;
    text-decoration: none;
  }
  .reviews-container .reviews-btn {
    padding: 10px 30px;
    margin-top: 30px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 13px;
    border-radius: 3px;
    border-width: 2px;
    border-style: solid;
    display: inline-block;
    text-decoration: none;
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    transition: .3s all ease;
    color: #fff;
    background: #101010;
    border-color: #101010;
  }
  .reviews-container .reviews-btn:hover,
  .reviews-container .reviews-btn:active,
  .reviews-container .reviews-btn:focus {
    background: #767676;
    border-color: #767676;
    text-decoration: none;
  }
  .reviews-container .carousel {
    margin: 30px auto;
  }
  .reviews-container .carousel .carousel-control.left,
  .reviews-container .carousel .carousel-control.right {
    background-image: none;
    width: 30px;
    -moz-transition: all 300ms ease-out;
    -webkit-transition: all 300ms ease-out;
    -o-transition: all 300ms ease-out;
    transition: all 300ms ease-out;
  }
  .reviews-container .carousel .carousel-control img {
    position: absolute;
    top: 50%;
    z-index: 105;
    display: inline-block;
    height: 20px;
  }
  .reviews-container .carousel .carousel-control.left img {
    left: 0;
  }
  .reviews-container .carousel .carousel-control.right img {
    right: 0;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner {
    position: relative;
    overflow: hidden;
    width: 100%;
    overflow-y: visible;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner>.item {
    display: none;
    position: relative;
    width: 100%;
  }

  @media all and (transform-3d),
  (-webkit-transform-3d) {
    .reviews-container #multiReviewsDesktop .carousel-inner>.item.next,
    .reviews-container #multiReviewsDesktop .carousel-inner>.item.active.right {
        left: 0;
        transform: translate3d(33.33333333333333%, 0, 0);
    }
    .reviews-container #multiReviewsDesktop .carousel-inner>.item.prev,
    .reviews-container #multiReviewsDesktop .carousel-inner>.item.active.left {
        left: 0;
        transform: translate3d(-33.33333333333333%, 0, 0);
    }
    .reviews-container #multiReviewsDesktop .carousel-inner>.item.next.left,
    .reviews-container #multiReviewsDesktop .carousel-inner>.item.prev.right,
    .reviews-container #multiReviewsDesktop .carousel-inner>.item.active {
        left: 0;
        transform: translate3d(0, 0, 0);
    }
  }

  .reviews-container #multiReviewsDesktop .carousel-inner .active,
  .reviews-container #multiReviewsDesktop .carousel-inner .next,
  .reviews-container #multiReviewsDesktop .carousel-inner .prev {
    display: block;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner .active {
    left: 0;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner .next,
  .reviews-container #multiReviewsDesktop .carousel-inner .prev {
    position: absolute;
    top: 0;
    width: 100%;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner .next {
    left: 33.33333333333333%;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner .prev {
    left: -33.33333333333333%;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner .next.left,
  .reviews-container #multiReviewsDesktop .carousel-inner .prev.right {
    left: 0;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner .active.left {
    left: -33.33333333333333%;
  }
  .reviews-container #multiReviewsDesktop .carousel-inner .active.right {
    left: 33.33333333333333%;
  }
  .reviews-container #multiReviewsDesktop .next .col-sm-4 {
    opacity: 0;
  }
  .reviews-container #multiReviewsDesktop .next .col-sm-4:last-of-type {
    opacity: 1 !important;
  }

  @media (max-width: 767px) {
    .reviews-container .carousel .item, .reviews-container .carousel .item .col-xs-12 {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (min-width: 1400px) {
    .reviews-container .container-xl {
      width: 1320px;
      max-width: 100%;
    }
  }
</style>